import { GpdrData } from './gpdr-data';

import { lang } from '../configuration';
import { Appointment, RequestAppointment } from './appointment';
import { Call } from './call';
import { Claim } from './claim';
import { CreationData } from './creation-data';
import { Customer } from './customer';
import { DossierExternalReferences } from './dossier-external-references';
import { DossierSearchLocation } from './dossier-search-location';
import { DossierState, DossierStateHistory } from './dossier-state';
import { FitterInfo } from './fitter-info';
import { Insurer, InsurerData } from './insurer';
import { MarketingData } from './marketing-data';
import { PolicyInformation } from './policy-information';
import { DossierComments } from './dossier-comments';
import { Nps } from './nps';

export interface Dossier {
  id?: string;
  externalId?: string;
  creationData: CreationData;
  createDate?: Date;
  updateDate?: Date;
  appointment?: Appointment;
  requestAppointment?: RequestAppointment;
  previousAppointments?: Appointment[];
  suggestedAppointments?: Appointment[];
  state?: DossierState;
  claim?: Claim;
  customer?: Customer;
  insurer: Insurer;
  policyInformation?: PolicyInformation;
  insurerData?: InsurerData;
  gpdr?: GpdrData;
  marketingData?: MarketingData;
  call?: Call[];
  stateHistory?: DossierStateHistory[];
  fitterInfo?: FitterInfo;
  searchCriteria?: DossierSearchLocation;
  selectedLanguage?: lang;
  currentlyInUse?: {
    userId: string;
    userName: string;
    timestamp: string;
  };
  custom?: {
    [key: string]: any;
  };
  canNotifyCustomer?: boolean;
  declarationPage?: string;
  externalReferences?: DossierExternalReferences;
  /** Canonical collection for every dossier comment, including migrated legacy fields. */
  dossierComments?: DossierComments[];
  nps?: Nps[];
  abTesting?: { abTestType: AbTestType; value: boolean }[];
}

export type AbTestType = 'b2c-early-customer-phone-number';

export type UsersRole =
  | 'grpInsurer'
  | 'grpInsurerAccessPartnerFitterOrGrpInsurerAdmin'
  | 'grpInsurerDashboard'
  | 'grpInsurerAccessClaimsList';

export type NotifyAction =
  | 'MODIFICATION'
  | 'NO_SHOW'
  | 'COMPLETED'
  | 'CUSTOMER_DOCUMENT_UPLOAD_EMAIL'
  | 'CUSTOMER_DOCUMENT_UPLOAD_SMS'
  | 'BOOK';

export enum DossierAgendaConcurencyActionEnum {
  Open = 'Open',
  Close = 'Close',
}

export type DossierGlobalOrigins =
  | 'SITE_WEB'
  | 'CALL_CENTER'
  | 'AGENDA'
  | 'OTHER'
  | 'PARTNER'
  | 'CHALLENGE'
  | 'API_OTHER'
  | 'BANQUE_POPULAIRE'
  | 'CAISSE_D_EPARGNE'
  | 'BCP'
  | 'CREDIT_COOPERATIF'
  | 'BRED'
  | 'MOBILE_APP'
  | 'MATMUT_AND_CO'
  | 'COURTIER'
  | 'CASER'
  | 'AICHAT'
  | 'RESERVE_WITH_GOOGLE';

export type DossierAgendaConcurencyAction =
  `${DossierAgendaConcurencyActionEnum}`;

export interface DossierDbFormat extends Dossier {
  _rid?: string;
  _self?: string;
  _etag?: string;
  _attachments?: string;
  _ts?: number;
}

export interface DossierByCustomerName {
  id: string;
  customerName: string;
  customerFirstName: string;
  licensePlateNumber: string;
}
